var chunkToChildrenMap = {
	"bundle": [
		"vendors-node_modules_filesize_lib_filesize_js-node_modules_react-dropzone_dist_es_index_js",
		"vendors-node_modules_react-range_lib_index_js-node_modules_react-router_es_Redirect_js",
		"vendors-node_modules_lodash__baseClone_js-node_modules_lodash__baseForOwn_js-node_modules_lod-fe83e6",
		"vendors-node_modules_react-color_es_index_js-node_modules_react-router-dom_es_Redirect_js",
		"src_ipm-shared_components_Form_controls_FilePicker_tsx",
		"src_ipm-shared_components_CollectionSplitFee_index_ts-src_ipm-shared_components_Form_controls-0ca621",
		"src_ipm-platform_pages_CollectedAccount_Settings_AdditionalSettings_index_ts-src_ipm-platform-165ad7",
		"Page_Settings",
		"src_ipm-shared_components_BankBSBId_index_tsx-src_ipm-shared_components_BankId_index_tsx",
		"Modal_WizardRentAdd",
		"src_ipm-platform_pages_WizardPayeeAdd_WizardInvoiceAdd_index_ts",
		"src_ipm-platform_pages_WizardPayeeAdd_WizardSalaryAdd_index_ts",
		"Page_WizardPayeeAdd",
		"Page_BePaidInvoiceCreation",
		"Page_Create",
		"Page_CustomerInvoiceDetails",
		"vendors-node_modules_zxcvbn_lib_main_js",
		"vendors-node_modules_recompose_index_js",
		"Page_SetNewPassword",
		"vendors-node_modules_react-responsive_dist_react-responsive_js-node_modules_react-router-dom_-128eac",
		"Page_BePaidCreateInvoice",
		"src_ipm-platform_pages_OnBoarding_Business_actions_ts-src_ipm-platform_pages_OnBoarding_Busin-cb442d",
		"Page_OnBoarding",
		"Page_OnBoardingStep2",
		"Page_WizardPayee",
		"vendors-node_modules_frames-react_index_js-node_modules_react-stripe-elements_es_index_js",
		"src_ipm-shared_components_CardForm_index_tsx",
		"Page_PaymentCollectionCheckout",
		"Page_Checkout",
		"src_ipm-platform_pages_AdminOperations_CancelRequests_index_tsx-src_ipm-platform_pages_AdminO-fef439",
		"src_ipm-platform_pages_AdminOperations_ScheduleRequests_BulkUploadFileRequest_index_tsx-src_i-e903ed",
		"Page_AdminOperations",
		"Page_WizardPayeeSummary",
		"Page_OnBoardingStep3",
		"Page_OnBoardingStep1",
		"node_modules_react-lazyload_lib_index_js-src_ipm-shared_components_Form_controls_Switch_tsx-s-689e48",
		"Page_AdminCollectedAccount",
		"Page_ChangePassword",
		"src_ipm-shared_components_BankId_index_tsx-src_ipm-shared_components_CardBank_index_tsx-src_i-058797",
		"Page_AdminAccountRates",
		"Page_BePaidPreviewInvoice",
		"BePaidUploadInvoice",
		"Page_AdminPromoCode",
		"Page_Customers",
		"BePaidSms",
		"Page_PaymentCollections",
		"Page_AddCustomer",
		"Page_WizardPayeeVerification",
		"Page_AdminUEN",
		"Page_PaymentConfirm",
		"Page_WizardPayeeSchedule",
		"Page_PaymentCancelled",
		"Page_PaymentMakeAlready",
		"Page_Employees",
		"Page_Invoices",
		"Page_MySchedules",
		"Page_PostRegister",
		"Page_Properties",
		"Page_MobileVerification",
		"Page_MyPayments",
		"Page_MyWallet",
		"Page_AdminInternational",
		"Page_AdminPaymentCheck",
		"Page_Companies",
		"Page_NotFound",
		"Page_ReferralProgram",
		"Page_Instruction",
		"Page_WorldpayTest"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };